export default function formatRecipient(recipient: {
  email: string;
  username: string;
  idMethod: string;
}) {
  const { email: rawEmail, username, idMethod } = recipient;
  let email = rawEmail;
  if (idMethod === 'username') {
    const tkns = email.split('@');
    let newAlias;
    if (tkns[0].length > 2) {
      newAlias = `${tkns[0].substring(0, 2)}${tkns[0].substring(2).replaceAll(/./g, '*')}`;
    } else {
      newAlias = `${tkns[0].replaceAll(/./g, '*')}`;
    }
    email = `${newAlias}@${tkns[1][0]}${tkns[1].substring(1).replaceAll(/./g, '*')}`;
  }
  const usernameSuffix = username ? ` (${username})` : '';
  return `${email}${usernameSuffix}`;
}
